import updateContactMessageDoc from '../../api/contactMessage/updateContactMessageDoc';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useUpdateContactMessage() {
  const {fn, loading, error} = useFunctionWrap(updateContactMessageDoc);

  return {updateContactMessage: fn, loading, error};
}
